import LogRocket from "logrocket";

let initialized = false;

/** Prod-only; no-ops if VITE_LOGROCKET_APP_ID is unset (mirrors the Mapbox-token pattern). */
export function initLogRocket(): void {
  if (initialized) return;
  if (!import.meta.env.PROD) return;
  const appId = import.meta.env.VITE_LOGROCKET_APP_ID;
  if (!appId) return;

  LogRocket.init(appId, {
    network: {
      requestSanitizer: (request) => {
        request.headers["Authorization"] = undefined;
        return request;
      },
      responseSanitizer: (response) => {
        response.headers["Authorization"] = undefined;
        return response;
      },
    },
  });
  initialized = true;
}

export function identifyLogRocketUser(
  userId: string,
  traits: Record<string, string | number | boolean>,
): void {
  if (!initialized) return;
  LogRocket.identify(userId, traits);
}
